import { Pencil } from "lucide-react";
import { Button } from "./Button";
import { forwardRef } from "react";

const UpdateButtonTrigger = forwardRef((props, ref) => {
  return (
    <Button {...props} variant="ghost" size="icon" ref={ref}>
      <Pencil className="w-4 h-4" />
    </Button>
  );
});

export default UpdateButtonTrigger;
